import { ButtonVariant } from '@/components/ButtonVariant';
import { LogoVariant } from '@/components/LogoVariant';
import { ID_RUBBELLOSE } from './ids';
import { GameConfig } from './index';

export const rubbellose: GameConfig = {
  id: ID_RUBBELLOSE,
  shortname: 'rubbellose',
  title: 'Rubbellose',
  imgPath: 'logo-rubbellose.svg',
  logo: LogoVariant.Rubbellose,
  button: ButtonVariant.Rubbellose,
  buttonSecondary: ButtonVariant.Secondary,
  drawDeadlines: [],
  jackpotDesc: '1 Million €',
  jackpotOfflineDescGame: 'Das Glück für zwischendurch',
  jackpotTimes: 'Gewinne bis zu',
  steps: [],
  urls: { stats: '', overview: '/rubbellose/informationen' },
  chanceDesc: 'Chance 1:800.000 (Diamant 7). Ab 18 J.',
};
